import { ServiceBusClient } from "@azure/service-bus"
import { v4 as uuidv4 } from "uuid"
import * as cookieHelper from "../helpers/cookie"

const connectionString =
  document.body && document.body.dataset.connectionstrings && JSON.parse(document.body.dataset.connectionstrings).trackingEventsSB
const topicName = "TrackingEventsTopic"

const sbClient = connectionString && ServiceBusClient.createFromConnectionString(connectionString)
const topicClient = sbClient && sbClient.createTopicClient(topicName)
const sender = topicClient && topicClient.createSender()

export const sendMessage = async (label, data) => {
  try {
    if (sender) {
      const message = {
        body: {
          data: data,
          headers: {
            Referer: document.referrer,
            "User-Agent": navigator.userAgent,
          },
          ids: getIds(),
          timestamp: Date.now(),
        },
        label: label,
      }
      await sender.send(message)
    }
  } finally {
    console.debug("serviceBus:sendMessage:done:")
    console.debug("label: " + label)
    console.debug(data)
  }
}

const getIds = () => {
  let tempUser = cookieHelper.getCookie("CPH.Temp.User.js")
  if (!tempUser) {
    tempUser = uuidv4()
    cookieHelper.setCookie("CPH.Temp.User.js", tempUser)
  }

  const ids = {
    LIID: cookieHelper.getCookie("CPH.LIID.js"),
    rr_session_id: cookieHelper.getCookie("rr_session_id"),
    AspNetSessionId: cookieHelper.getCookie("ASP.NET_SessionId.js"),
    TempUser: tempUser,
  }
  return ids
}
